import { Component, OnInit } from '@angular/core';
import { CommonsService } from '../commons-service';
import { CustomerModel } from '../models/customer-model';
import { RepositoryService } from '../repository.service';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
declare const $: any;
declare const log: any;

@Component({
  selector: 'app-view-customers-sugg-freq',
  templateUrl: './view-customers-sugg-freq.component.html',
  styleUrls: ['./view-customers-sugg-freq.component.css']
})
export class ViewCustomersSuggFreqComponent implements OnInit {

  customers: CustomerModel[] = []
  momentFrom: moment.Moment = moment().subtract(1, 'month');
  momentTo: moment.Moment = moment();
  textFromTo: string = ""

  constructor(
    private repository: RepositoryService,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.init()
  }

  async init() {
    this.momentTo = moment();
    this.momentTo.hour(23);
    this.momentTo.minute(59);
    this.momentTo.second(59);
    this.momentTo.millisecond(999);
    this.momentFrom = this.momentTo.clone().subtract(1, 'month');
    this.momentFrom.hour(0);
    this.momentFrom.minute(0);
    this.momentFrom.second(0);
    this.momentFrom.millisecond(0);
    this.textFromTo = this.momentFrom.format("DD.MM.YYYY") + " - " + this.momentTo.format("DD.MM.YYYY");

    const this_ = this;
    $('#div-date-range-1').daterangepicker({
      // minDate: moment(0),
      // maxDate: moment().endOf('day'),
      startDate: this.momentFrom.clone(),
      endDate: this.momentTo.clone(),
      timePicker: false,
      opens: 'left',
      singleDatePicker: false,
      showDropdowns: false,
      linkedCalendars: true,            // false testen (zeigt normalerweise 2 Kalender nebeneinander)
      alwaysShowCalendars: true,         // erzwingt Anzeige der Kalender
      locale: {
        format: 'DD.MM.YYYY',
        "applyLabel": this.translate.instant("GENERAL_APPLY"),
        "cancelLabel": this.translate.instant("GENERAL_CANCEL"),
        // "firstDay": 1
      }
    }).on('apply.daterangepicker', function (ev: any, picker: any) {
      log("date range selected", picker.startDate.toDate(), picker.endDate.toDate());
      this_.momentFrom = picker.startDate;
      this_.momentTo = picker.endDate;
      this_.textFromTo = this_.momentFrom.format("DD.MM.YYYY") + " - " + this_.momentTo.format("DD.MM.YYYY");
      this_.search();
    });

    this.search();
  }

  async search() {
    // let dateMin = new Date(0);

    // let dateCompare = new Date();
    // dateCompare.setHours(23);
    // dateCompare.setMinutes(59);
    // dateCompare.setSeconds(59);
    // dateCompare.setMilliseconds(999);
    this.momentTo.hour(23);
    this.momentTo.minute(59);
    this.momentTo.second(59);
    this.momentTo.millisecond(999);
    this.momentFrom.hour(0);
    this.momentFrom.minute(0);
    this.momentFrom.second(0);
    this.momentFrom.millisecond(0);

    let customersR = <CustomerModel[]>await this.repository.customers.readAll("lastName", true)
    customersR = customersR.filter((customer: CustomerModel) => {
      if (customer.lastContact && customer.contactFrequencyDays) {

        if (Number.isInteger(customer.contactFrequencyDays) && customer.contactFrequencyDays > 0) {
          var dateNextFreq = new Date(customer.lastContact);

          dateNextFreq.setDate(dateNextFreq.getDate() + customer.contactFrequencyDays);

          if (dateNextFreq.getTime() <= this.momentTo.toDate().getTime() &&
            dateNextFreq.getTime() >= this.momentFrom.toDate().getTime()) {
            customer.dateNextFreq = dateNextFreq;
            customer.textNextContact = CommonsService.formatDate0(dateNextFreq);
            return true
          }
        }
      }

      return false
    })

    customersR.sort(function (customerA, customerB) {
      return customerA.dateNextFreq.getTime() - customerB.dateNextFreq.getTime();
    });

    this.customers = customersR
  }

}
